import { useForm } from "react-hook-form";
import { FormInput } from "../../shared/formElements/formInput/FormInput";
import { FormCheckboxChips } from "../../shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { formatDate } from "../../../utils/formatNumber";
import { FormTextarea } from "../../shared/formElements/formTextarea/FormTextarea";
import classes from "./refundInitiationDetailForm.module.css";

// 🔹 APPROVE ONLY, Pending is default
const RefundStatus = [
  { id: "0", label: "Pending" }, // default state
  { id: "41", label: "Approve" }, // admin action
];

export const RefundInitiationDetailForm = ({
  initialValues,
  onSubmit,
  isSubmitting,
}) => {
  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      order_status: String(initialValues.order_status_code ?? "0"),
      remarks: "",
    },
  });

  // current selection
  const orderStatus = watch("order_status");

  // disable status change if already processed
  const isDisabled = initialValues.status !== "Refund Requested";

  // submit disabled if already processed or loading
  const disableSubmit = isSubmitting || isDisabled;

  const handleFormSubmit = (data) => {
    const payload = {
      order_id: initialValues.id,
      order_status: Number(data.order_status),
    };

    onSubmit(payload);
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(handleFormSubmit)}>
      <div className={classes.columnsWrapper}>
        <div className={classes.section}>
          <div className={classes.grid}>
            <FormInput label="Refund ID" value={initialValues.id} readOnly />

            <FormInput
              label="Order ID"
              value={initialValues.order_id}
              readOnly
            />

            <FormInput
              label="Delivered On"
              value={formatDate(initialValues.delivered_on)}
              readOnly
            />

            <FormInput
              label="Postal Code"
              value={initialValues.postal_code}
              readOnly
            />

            <FormInput
              label="Total Amount"
              value={initialValues.price}
              readOnly
            />

            <FormCheckboxChips
              id="order_status"
              label="Status"
              options={RefundStatus}
              watch={watch}
              setValue={setValue}
              register={register}
              disabled={isDisabled}
            />
          </div>

          <div className={classes.grid}>
            <FormTextarea
              id="reason"
              label="Reason"
              value={initialValues.reason}
              disabled
            />

            {/* 🔹 Remarks always disabled since reject is removed */}
            <FormTextarea
              id="remarks"
              label="Remarks"
              placeholder="Not required"
              disabled
            />
          </div>
        </div>
      </div>

      <div className={classes.actions}>
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={disableSubmit}
        >
          {isSubmitting ? "Updating..." : "Approve Refund"}
        </button>
      </div>
    </form>
  );
};
